export const theme = {
  color: {
    blue: '#2071ff',
    red: '#f70000',
    grey: '#4a5577',
    greyDark: '#15202b',
    white: '#fff',
    yellow: '#fdbe20',
    green: '#05db05',
    brawlBall: '#8d9fe0',
    gemGrab: '#9a3df4',
    heist: '#d55cd3',
    knockout: '#f78318',
    hotZone: '#e33b50',
    bounty: '#00cfff',
    wipeout: '#fe1cb8',
  },
  team: {
    blue: '#2373ff',
    red: '#bf1845',
  },
  brawler: {
    border: '#fff',
  },
  unit: 'vmin',
};

export type ThemeColors = keyof typeof theme.color;
export type ThemeType = typeof theme;
